/*
 * @Author: your name
 * @Date: 2019-06-16 10:03:09
 * @LastEditTime: 2020-02-26 13:43:42
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \source\src\utility\tdtService\Query\Model\ResultAreaTypeInfo.js
 */
import { AreaInfo } from "./AreaInfo";
import { QueryResultInfo } from "./QueryResultInfo"

/// <summary>
/// 结果类型为行政区省信息
/// </summary>
export class ResultAreaTypeInfo extends QueryResultInfo {

	constructor() {
		super();
		//行政区省信息
		this.area = null;
	}


	static GetResultAreaTypeInfo(jsonObj) {
		let areaTypeInfo = null;
		if (jsonObj == null) return areaTypeInfo;
		areaTypeInfo = new ResultAreaTypeInfo();
		areaTypeInfo.resultType=jsonObj.resultType;
		areaTypeInfo.area = AreaInfo.GetAreaInfo(jsonObj.area);
		return areaTypeInfo;
	}

}//end ResultAreaTypeInfo

